import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from './brunovitaltattoo.module.scss';
import Logo from './src/perfil.png';
import VideoFundo from './src/background-links.mp4';
import PosterFundo from './src/background-links.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import { INSTAGRAM_URL, MAPS_URL, WHATSAPP_DEFAULT, useBrunoBackground } from './dados_brunovitaltattoo.ts';

const ease = [0.22, 1, 0.36, 1] as const;

const list = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: { staggerChildren: 0.1, delayChildren: 0.28 },
    },
};

const item = {
    hidden: { opacity: 0, y: 18 },
    show: { opacity: 1, y: 0, transition: { duration: 0.55, ease } },
};

const Brunovitaltattoo: React.FC = () => {
    useBrunoBackground();

    return (
        <div className={styles.brunovitaltattoo} lang="pt-BR">
            <div className={styles.hero}>
                <video
                    className={styles.heroVideo}
                    src={VideoFundo}
                    poster={PosterFundo}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                    aria-hidden="true"
                />
                <div className={styles.heroFade} />

                <motion.div className={styles.content} variants={list} initial="hidden" animate="show">
                    <motion.img
                        className={styles.logo}
                        src={Logo}
                        alt="Bruno Vital Tattoo"
                        variants={item}
                    />

                    <motion.h1 className={styles.headline} variants={item}>
                        A tatuagem é mais que estética — é um ritual simbólico de transformação.
                    </motion.h1>

                    <motion.div className={styles.proposito} variants={item}>
                        <p className={styles.propositoLabel}>Propósito</p>
                        <p className={styles.propositoText}>
                            Ajudar pessoas a eternizarem na pele suas histórias de superação, cura e
                            renascimento, transformando cada tatuagem em um emblema do seu próprio
                            poder heróico.
                        </p>
                    </motion.div>

                    <motion.div className={styles.ctas} variants={item}>
                        <Link to="/brunovitaltattoo/sobremim" className={styles.cta}>
                            Saiba mais
                        </Link>
                        <Link to="/brunovitaltattoo/tattoo" className={styles.cta}>
                            Ver galeria
                        </Link>
                    </motion.div>

                    <motion.div className={styles.socials} variants={item}>
                        <motion.a
                            href={WHATSAPP_DEFAULT}
                            className={styles.social}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="WhatsApp"
                            whileHover={{ y: -2 }}
                            whileTap={{ scale: 0.94 }}
                        >
                            <WhatsappIcon height="26" color="#f3f1ec" />
                        </motion.a>
                        <motion.a
                            href={INSTAGRAM_URL}
                            className={styles.social}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            whileHover={{ y: -2 }}
                            whileTap={{ scale: 0.94 }}
                        >
                            <InstagramIcon height="20" color="#f3f1ec" />
                        </motion.a>
                        <motion.a
                            href={MAPS_URL}
                            className={styles.social}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Localização"
                            whileHover={{ y: -2 }}
                            whileTap={{ scale: 0.94 }}
                        >
                            <MapsIcon height="26" color="#f3f1ec" />
                        </motion.a>
                    </motion.div>

                    <motion.div className={styles.extraLinks} variants={item}>
                        <Link to="/brunovitaltattoo/depoimentos">Depoimentos</Link>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
};

export default Brunovitaltattoo;
